export class Balance {
  AddValues: AddValue[];
  Consumptions:Consumption[];
  constructor(){
    this.AddValues = [];
    this.Consumptions = [];
  }
}

export class AddValue {
  Date: string;
  StoreName:string;
  Amount: number;
}

export class Consumption {
  Date: string;
  StoreName:string;
  Amount: number;
}